var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIdeac7149F90(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 41,
    viewBox: "0 0 40 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_442_69)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.25 30.6667C27 28.1746 28.5547 26.0496 30.0938 23.9324C30.5 23.3777 30.9062 22.823 31.2969 22.2605C32.8438 20.0339 33.75 17.3386 33.75 14.4246C33.75 6.823 27.5938 0.666748 20 0.666748C12.4062 0.666748 6.25 6.823 6.25 14.4167C6.25 17.3308 7.15625 20.0339 8.70312 22.2527C9.09375 22.8152 9.5 23.3699 9.90625 23.9246C11.4531 26.0417 13.0078 28.1746 13.75 30.6589H26.25V30.6667ZM20 40.6667C23.4531 40.6667 26.25 37.8699 26.25 34.4167V33.1667H13.75V34.4167C13.75 37.8699 16.5469 40.6667 20 40.6667ZM13.75 14.4167C13.75 15.1042 13.1875 15.6667 12.5 15.6667C11.8125 15.6667 11.25 15.1042 11.25 14.4167C11.25 9.58081 15.1641 5.66675 20 5.66675C20.6875 5.66675 21.25 6.22925 21.25 6.91675C21.25 7.60425 20.6875 8.16675 20 8.16675C16.5469 8.16675 13.75 10.9636 13.75 14.4167Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.078125
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_442_69"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white",
    transform: "translate(0 0.666748)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIdeac7149F90);
export default __webpack_public_path__ + "static/media/idea.c7149f90.d2c6459002b59a39443b09eeadc8c7cd.svg";
export { ForwardRef as ReactComponent };